export default "/lineup-tool/assets/redux/times.svg";